import { colorsV2 } from '../../../colors-v2';
import { ColorDefinition } from '../../elements/highlight/types';

export const MARK_UNDERLINE_COLOR = 'UNDERLINE_COLOR';

export const DEFAULT_UNDERLINE_COLORS = {
  black100: {
    color: colorsV2.black100,
    key: 'black100',
  },
  yellow100: {
    color: colorsV2.yellow100,
    key: 'yellow100',
  },
  green100: {
    color: colorsV2.green100,
    key: 'green100',
  },
  red100: {
    color: colorsV2.red100,
    key: 'red100',
  },
  blue100: {
    color: colorsV2.blue100,
    key: 'blue100',
  },
  purple100: {
    color: colorsV2.purple100,
    key: 'purple100',
  },
  pink100: {
    color: colorsV2.pink100,
    key: 'pink100',
  },
};

export const DEFAULT_UNDERLINE_COLOR_LIST: ColorDefinition[] = [
  DEFAULT_UNDERLINE_COLORS.black100,
  DEFAULT_UNDERLINE_COLORS.red100,
  DEFAULT_UNDERLINE_COLORS.yellow100,
  DEFAULT_UNDERLINE_COLORS.purple100,
  DEFAULT_UNDERLINE_COLORS.green100,
  DEFAULT_UNDERLINE_COLORS.blue100,
];

export const DEFAULT_UNDERLINE_COLOR = {
  underlineColor: {
    type: MARK_UNDERLINE_COLOR,
    colors: DEFAULT_UNDERLINE_COLOR_LIST,
    defaultColor: DEFAULT_UNDERLINE_COLORS.black100,
  },
};
